// extracted by mini-css-extract-plugin
export default {"pagination":"event_pagination__gTU39","page-link":"event_page-link__XwHO3","container":"event_container__3ZV6o","header":"event_header__ZnPN9","agenda":"event_agenda__+lQqc"};